import React, { Component } from "react";
import styled from "styled-components";
import { RadioGroup, Radio } from "react-radio-group";
import { connect } from "react-redux";
import { push } from "react-router-redux";
import { bindActionCreators } from "redux";
import { flow } from "lodash";
import { graphql, compose } from "react-apollo";
import gql from "graphql-tag";

import { completeInterview, setInterval } from "../../modules/interviewResult";

const Content = styled.div`
  h2 {
    margin-bottom: 8px;
  }

  p {
    font-weight: 300;
    font-size: 12px;
    color: #959595;
    letter-spacing: 0.94px;
    line-height: 23px;
    margin-bottom: 20px;
  }

  input {
    margin-bottom: 20px;
    display: block;
    float: none;
    padding: 20px;
  }
`;

const RadioContainer = styled.label`
  padding: 10px;
  margin-bottom: 10px;
  border-radius: 3px;
  display: block;

  input {
    display: inline;
    margin-right: 15px;
    margin-bottom: 6px;
  }

  label {
    color: #696969;
    font-size: 12px;
  }
`;

const enabledRadio = { border: "1px solid #34A8F0" };
const disabledRadio = { border: "1px solid rgba(0,0,0,0.1)" };

const Next = styled.a`
  background: #ffffff;
  border: 1px solid #34a8f0;
  box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.21);
  border-radius: 3px;
  text-transform: uppercase;
  color: #34a8f0;
  padding: 15px 0;
  text-decoration: none;
  cursor: pointer;
`;

const enabledNext = { pointerEvents: "initial", opacity: 1 };
const disabledNext = { pointerEvents: "none", opacity: 0.3 };

class OBFive extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedValue: null
    };
  }

  onChange = value => {
    this.setState({ selectedValue: value });
  };

  finish() {
    this.props
      .updateAccount(
        parseInt(this.props.data.account.account_apps[0].id),
        this.props.selectedEvent,
        this.state.selectedValue
      )
      .then(result => {
        this.props.setInterval(this.state.selectedValue);
        this.props.completeInterview();
        this.props.changePage("/setup/success");
      })
      .catch(err => {
        console.log("there has been an error", err);
      });
  }

  render() {
    return (
      <Content>
        <h2>Usage Interval</h2>
        <p>How often do customers use your product?</p>
        <RadioGroup
          selectedValue={this.state.selectedValue}
          onChange={this.onChange}
          style={{ marginBottom: "40px", textAlign: "left" }}
        >
          <RadioContainer
            style={
              this.state.selectedValue === "day" ? enabledRadio : disabledRadio
            }
          >
            <Radio value="day" /> At least once a day{" "}
          </RadioContainer>
          <RadioContainer
            style={
              this.state.selectedValue === "week" ? enabledRadio : disabledRadio
            }
          >
            <Radio value="week" /> At least once a week{" "}
          </RadioContainer>
          <RadioContainer
            style={
              this.state.selectedValue === "month"
                ? enabledRadio
                : disabledRadio
            }
          >
            <Radio value="month" /> At least once a month{" "}
          </RadioContainer>
        </RadioGroup>
        <Next
          style={this.state.selectedValue ? enabledNext : disabledNext}
          onClick={() => {
            this.finish();
          }}
        >
          Finish
        </Next>
      </Content>
    );
  }
}

const mapStateToProps = state => {
  return { selectedEvent: state.interview.selectedEvent };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      completeInterview,
      setInterval,
      changePage: location => push(location)
    },
    dispatch
  );

const interviewResultMutation = gql`
  mutation updateAccountApp(
    $id: Int!
    $usage_frequency: String
    $critical_event_name: String
  ) {
    updateAccountApp(
      id: $id
      usage_frequency: $usage_frequency
      critical_event_name: $critical_event_name
    ) {
      id
    }
  }
`;

const getIdQuery = gql`
  query {
    account {
      account_apps {
        id
      }
    }
  }
`;

const OnBoardingFive = flow(
  connect(mapStateToProps, mapDispatchToProps),
  compose(
    graphql(interviewResultMutation, {
      props: ({ mutate }) => ({
        updateAccount: (id, critical_event_name, usage_frequency) =>
          mutate({ variables: { id, critical_event_name, usage_frequency } })
      })
    }),
    graphql(getIdQuery)
  )
)(OBFive);

export default OnBoardingFive;



// WEBPACK FOOTER //
// ./src/containers/onBoard/onboardingFive.js